import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getProduct({ commit, dispatch, getters, rootGetters }, { productId }) {
    const loggedIn = rootGetters['auth/loggedIn']
    const url = `/api/${loggedIn ? 'end_user' : 'public'}/products/${productId}`
    return axios.get(url).then((response) => {
      return response.data
    })
  },
  getMyProducts({ commit, dispatch, getters }) {
    return axios.get(`/api/end_user/myProducts`).then((response) => {
      return response.data
    })
  },
  addTracker({ commit, dispatch, getters }, {url}) {
    return axios.post(`/api/end_user/customTrackers`, { url })
  },
  deleteTracker({ commit, dispatch, getters }, tracker) {
    return axios.delete(`/api/end_user/customTrackers/${tracker.id}`).then((response) => {
      return response.data
    })
  },
  getCustomTrackers({ commit, dispatch, getters }) {
    return axios.get(`/api/end_user/customTrackers`).then((response) => {
      return response.data
    })
  },
  async subscribeToProduct({ commit, dispatch, getters, rootGetters }, { productId } = {}) {
    const loggedIn = rootGetters['auth/loggedIn']
    const isAppLogin = rootGetters['auth/isAppLogin']
    if (loggedIn === false && isAppLogin) {
      window.location.href = `https://app.inventorybot.io/app/launchAppLogin`
      return
    }

    return axios
      .post(`/api/end_user/subscriptions/registerProduct`, { productId })
      .then((response) => {
        return response.data
      });
  },
  unsubscribeToProduct({ commit, dispatch, getters }, { productId } = {}) {
    return axios
      .post(`/api/end_user/subscriptions/unregisterProduct`, { productId })
      .then((response) => {
        return response.data
      })
  },
  subscribeToProductSource({ commit, dispatch, getters, rootGetters }, { uniqueId, zipCode } = {}) {
    const loggedIn = rootGetters['auth/loggedIn']
    const isAppLogin = rootGetters['auth/isAppLogin']
    if (loggedIn === false && isAppLogin) {
      window.location.href = `https://app.inventorybot.io/app/launchAppLogin`
      return
    }

    return axios
      .post(`/api/end_user/subscriptions/registerProductSource`, { uniqueId, zipCode })
      .then((response) => {
        return response.data
      })
  },
  unsubscribeToProductSource({ commit, dispatch, getters }, { uniqueId, zipCode } = {}) {
    return axios
      .post(`/api/end_user/subscriptions/unregisterProductSource`, {
        uniqueId,
        zipCode
      })
      .then((response) => {
        return response.data
      })
  },
  searchForProducts({ commit, dispatch, getters, rootGetters }, { query }) {
    const loggedIn = rootGetters['auth/loggedIn']
    const url = `/api/${loggedIn ? 'end_user' : 'public'}/products/search?query=${encodeURIComponent(query)}`
    return axios
      .get(url)
      .then((response) => {
        return response.data
      })
  },
}
